<template>
  <div class="notes" :class="{ mini: showMiniClass, show: show }">
    <div class="notes-body">
      <div class="row">
        <div class="col-md-4 notes-column">
          <div class="notes-form">
            <fieldset>
              <legend>New Note</legend>
              <div class="notes-input">
                <input-block
                  placeholder="Note..."
                  :stacked="true"
                  name="note"
                  v-model="form.note"
                ></input-block>
              </div>

              <div class="row">
                <selectlist
                  v-if="noteCategories"
                  :options="noteCategories"
                  v-model="form.note_category_id"
                  label="Category"
                  name="note_category"
                  placeholder="Please Select"
                  :show-error="form.errors.has('note_category_id')"
                ></selectlist>

                <selectlist
                  v-if="noteSubjects"
                  :options="noteSubjects"
                  v-model="form.note_subject_id"
                  label="Subject"
                  name="note_subject"
                  placeholder="Please Select"
                  :show-error="form.errors.has('note_subject_id')"
                ></selectlist>
              </div>

              <form-button
                v-if="!readonly"
                :indicator="form.processing()"
                v-on:clicked="save"
              >
                Save Note
              </form-button>
            </fieldset>
          </div>
        </div>
        <div class="col-md-8 notes-column">
          <fieldset>
            <legend class="form-inline clearfix">
              Notes
              <selectlist
                v-if="noteCategories"
                :options="noteCategories"
                v-model="desired_category_id"
                name="desired_category"
                placeholder="Select Category"
              ></selectlist>

              <selectlist
                v-if="noteSubjects"
                :options="noteSubjects"
                v-model="desired_subject_id"
                name="desired_subject"
                placeholder="Select Subject"
              ></selectlist>

              <form-button v-on:clicked="resetCategories">Reset</form-button>

              <div class="float-right">
                <div class="btn-group margin-r-5" @click.stop>
                  <button
                    type="button"
                    class="btn btn-primary btn-xs"
                    v-on:click.prevent="toggleDownloadDropdown"
                  >
                    <i class="material-icons">cloud_download</i>
                  </button>
                  <div v-if="showDownloadDropdown" class="dropdown-menu dropdown-menu-right show">
                    <a class="dropdown-item" href="#" v-on:click.prevent="download('all')">All</a>
                    <a class="dropdown-item" href="#" v-on:click.prevent="download('client_insurer')">Client Insurer</a>
                    <a class="dropdown-item" href="#" v-on:click.prevent="download('third_party_insurer')">Third Party Insurer</a>
                    <a class="dropdown-item" href="#" v-on:click.prevent="download('client_and_third_party_insurer')">Client and Third Party Insurer</a>
                  </div>
                </div>

                <button
                  class="btn btn-primary btn-xs"
                  v-on:click.prevent="closeNotes"
                >
                  <i class="material-icons">
                    cancel
                  </i>
                </button>
              </div>
            </legend>
          </fieldset>

          <div class="notes-container">
            <div
              class="note d-flex justify-content-between"
              v-for="(note, index) in outputNotes"
              v-bind:key="index"
            >
              <div v-if="noteShouldDisplay(note)">
                <p v-html="note.body"></p>

                <strong
                  >{{ note.user?.first_name }} {{ note.user?.last_name }} |
                  {{ note.created_at | dateFormat('DD/MM/YYYY HH:mm') }} |
                  <span v-if="note.note_category_id"
                    >{{
                      note.note_category_id | noteCategory(noteCategories)
                    }}
                    |</span
                  >
                  <span v-if="note.note_subject_id">{{
                    note.note_subject_id | noteSubject(noteSubjects)
                  }}</span>
                </strong>
              </div>
              <div class="text-right" v-if="noteShouldDisplay(note)">
                <button
                  class="btn btn-danger btn-xs ml-2"
                  v-on:click="deleteNotes(note, index)"
                  v-if="hasPermission('notes.delete')"
                >
                  <i class="material-icons">
                    cancel
                  </i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    incident: String,
    show: Boolean,
    rejected: Boolean,
    create: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      indicator: false,
      deleting: false,
      showDownloadDropdown: false,
      desired_category_id: null,
      desired_subject_id: null,
      form: new window.Form(
        {
          note: null,
          note_category_id: null,
          note_subject_id: null
        },
        true
      ),
      notes: [],
      noteCategories: [],
      noteSubjects: []
    };
  },

  mounted() {
    this._closeDropdown = () => {
      this.showDownloadDropdown = false;
    };
    document.addEventListener('click', this._closeDropdown);

    window.Ajax.get('/incidents/note/categories')
      .then(response => {
        this.noteCategories = response.data;

        window.Ajax.get('/incidents/note/subjects')
          .then(response => {
            this.noteSubjects = response.data;

            window.Ajax.get(
              `incidents/${this.incident}/notes?filter[status]=${
                this.rejected ? 'rejected' : 'open'
              }`
            )
              .then(response => {
                this.notes = response.data;
              })
              .catch(error => {});
          })
          .catch(error => {});
      })
      .catch(error => {});
  },

  beforeDestroy() {
    document.removeEventListener('click', this._closeDropdown);
  },

  filters: {
    dateFormat(value, format = 'DD/MM/YYYY') {
      return window.DateManager.format(value, format);
    },
    noteCategory(value, categories) {
      let found = categories.find(item => {
        return item.id === value;
      });

      return found ? found.label : '';
    },
    noteSubject(value, subjects) {
      let found = subjects.find(item => {
        return item.id === value;
      });

      return found ? found.label : '';
    }
  },

  computed: {
    showMiniClass() {
      return this.$store.getters.isSidebarVisible;
    },

    outputNotes() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.notes.sort((first, second) => {
        let a = window.DateManager.parse(first.created_at);
        let b = window.DateManager.parse(second.created_at);

        if (window.DateManager.isAfter(a, b)) {
          return -1;
        }

        if (window.DateManager.isBefore(a, b)) {
          return 1;
        }

        return 0;
      });
    },

    readonly() {
      return this.isReadonly();
    }
  },

  methods: {
    save() {
      this.indicator = true;

      if (this.form.isEmpty('note')) {
        window.toastify.error('Error', 'Sorry, you must enter a note');
      } else {
        this.form
          .post(`/incidents/${this.incident}/notes`)
          .then(response => {
            window.toastify.success(
              'Note Added',
              'The note was added successfully!'
            );

            this.notes.push(response);
          })
          .catch(error => {
            window.toastify.error(
              'Error',
              'There was an error saving the note'
            );
          });
      }
    },

    deleteNotes(note, index) {
      this.deleting = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'Are you sure you want to delete that note?',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          window.Ajax.delete(
            `/incidents/${this.incident}/notes/${note.identifier}`
          )
            .then(() => {
              this.notes.splice(index, 1);

              window.toastify.success(
                'Deleted',
                'The note was deleted successfully!'
              );

              this.deleting = false;
            })
            .catch(() => {
              window.toastify.error(
                'Sorry, there was an issue deleting the note'
              );

              this.deleting = false;
            });
        })
        .catch(err => {
          this.deleting = false;
        });
    },

    noteShouldDisplay(note) {
      let shouldDisplay = true;

      if (
        this.desired_category_id &&
        note.note_category_id != this.desired_category_id
      ) {
        shouldDisplay = false;
      }

      if (
        this.desired_subject_id &&
        note.note_subject_id != this.desired_subject_id
      ) {
        shouldDisplay = false;
      }

      return shouldDisplay;
    },

    toggleDownloadDropdown() {
      this.showDownloadDropdown = !this.showDownloadDropdown;
    },

    download(subject = 'all') {
      const token = window.Token.get();
      let url = `${window.AxisUK.api}/incidents/${this.incident}/notes/download?token=${token}`;

      if (subject && subject !== 'all') {
        url += `&subject=${subject}`;
      }

      window.open(url);
      this.showDownloadDropdown = false;
    },

    resetCategories() {
      this.desired_category_id = null;
      this.desired_subject_id = null;
    },

    closeNotes() {
      this.$emit('toggle-note');
    }
  }
};
</script>

<style scoped>
.btn.close-button {
  padding: 4px 12px !important;
}
</style>
